var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpBox",
    { staticClass: "h-100 overflow-hidden", attrs: { direction: "column" } },
    [
      _c("table", [
        _c("tbody", [
          _c("tr", [
            _c("td", [
              _vm._v(
                "\n          " +
                  _vm._s(_vm._f("pgettext")("Job ID", "Job")) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "px-3" }, [
              _vm._v("\n          " + _vm._s(_vm.item.id) + "\n        ")
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _vm._v(
                "\n          " +
                  _vm._s(_vm._f("pgettext")("Job name", "Job")) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "px-3" }, [
              _vm._v("\n          " + _vm._s(_vm.item.name) + "\n        ")
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _vm._v(
                "\n          " +
                  _vm._s(_vm._f("pgettext")("Submitter", "Job")) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "px-3" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm._f("username")(_vm.item.created_by)) +
                  "\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _vm._v(
                "\n          " +
                  _vm._s(_vm._f("pgettext")("Submit time", "Job")) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "px-3" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm._f("datetime")(_vm.item.submit_time)) +
                  "\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _vm.item.execution_time
            ? _c("tr", [
                _c("td", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm._f("pgettext")("Execution time", "Job")) +
                      "\n        "
                  )
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "px-3" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$fn.humanizeDuration(_vm.item.execution_time)
                      ) +
                      "\n        "
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.item.message
            ? _c("tr", [
                _c("td", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm._f("pgettext")("Message", "Job")) +
                      "\n        "
                  )
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "px-3" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.item.message) + "\n        "
                  )
                ])
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("HR"),
      _vm._v(" "),
      _vm.hasFiles ? _c("JobFiles", { attrs: { item: _vm.item } }) : _vm._e(),
      _vm._v(" "),
      _vm.hasFiles ? _c("HR") : _vm._e(),
      _vm._v(" "),
      _vm.hasChildJobs
        ? _c("ChildJobs", { attrs: { parent: _vm.item } })
        : _vm._e(),
      _vm._v(" "),
      _c("JobRuns", { attrs: { item: _vm.item } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }